export function pickRandomBackgroundImage() {
    const colors = [
        "linear-gradient(to bottom right, #ececec, #dfdfdf)",
        "linear-gradient(to bottom right, #ececec, #dfdfdf)",
        "linear-gradient(to bottom right, #ececec, #dfdfdf)",
        "linear-gradient(to bottom right, #ececec, #dfdfdf, #dfdfdf)",
    ]
    let size = colors.length - 1
    const randomIndex = Math.floor(Math.random() * size)
    return colors[randomIndex]
}

export function pickWhiteGrayGradient() {
    return "linear-gradient(to bottom, #ffffff, #fefefe, #fdfdfd, #fcfcfc, #fbfbfb, #fafafa, #f9f9f9, #f8f8f8, #f7f7f7, #f6f6f6, #f5f5f5, #f4f4f4, #f3f3f3, #f2f2f2, #f1f1f1, #eeeeee, #ededed, #ececec, #ebebeb, #eaeaea, #e9e9e9, #e8e8e8, #e7e7e7, #e6e6e6, #e5e5e5, #e4e4e4, #e3e3e3, #e2e2e2, #e1e1e1, #dedede, #dddddd, #dcdcdc, #dbdbdb, #dadada, #d9d9d9, #d8d8d8, #d7d7d7, #d6d6d6, #d5d5d5, #d4d4d4, #d3d3d3, #d2d2d2, #d1d1d1)"
}


export const deviceQuery1 =
    {query: '(min-width: 501px) and (max-width: 700px)'}

export const deviceQuery2 =
    {query: '(min-width: 701px) and (max-width: 991px)'}